import { observer } from "mobx-react";

import Icon from "../../../decorations/icons/icon";
import Tooltip from "../../../tooltip/tooltip";

import { TooltipList, TooltipNote, TooltipNoteLink } from "./upload.styles";

interface ErrorTooltipProps {
    articleUrl?: string;
    upload: {
        errorMessages: string[];
    };
}

const ErrorTooltip = observer(({ upload, articleUrl }: ErrorTooltipProps) => {
    if (Array.isArray(upload.errorMessages)) {
        return (
            <Tooltip
                innerHtml={
                    <>
                        <TooltipList>
                            {upload.errorMessages.map((msg) => {
                                return (
                                    <li key={msg}>
                                        <p>{msg}</p>
                                    </li>
                                );
                            })}
                        </TooltipList>
                        {articleUrl && (
                            <TooltipNote>
                                For more information on supported media formats
                                please see
                                <TooltipNoteLink
                                    href={articleUrl}
                                    target="_blank"
                                >
                                    {` `}this article.
                                </TooltipNoteLink>
                            </TooltipNote>
                        )}
                    </>
                }
                position="right"
                size="big"
            >
                <Icon name="info" />
            </Tooltip>
        );
    } else {
        return null;
    }
});

export default ErrorTooltip;
